export const certikLink = 'https://skynet.certik.com/projects/cratd2c';
export const hackenLink = 'https://hacken.io/audits/cratd2c-decentralized-autonomous-smart-chain/';
export const tgCratD2CLink = 'https://t.me/CratD2CSmartChain';
export const dsCratD2CLink = 'https://discord.gg/eyjrSFXUbW';
export const twCratD2CLink = 'https://twitter.com/CratD2C';
export const linkedinCratD2CLink = 'https://www.linkedin.com/company/cratd2csmartchain/';
export const youtubeCratD2CLink = 'https://www.youtube.com/@CratD2CSmartChain';
export const facebookCratD2CLink = 'https://www.facebook.com/cratd2c';
